
import Vue from "vue";
import { ISearchHit } from "../store/state";
interface HitProps {
  hit: ISearchHit;
}

export default Vue.extend<{}, {}, {}, HitProps>({
  name: "Hit",
  props: {
    hit: {},
  },
});
